import React, { FC } from 'react';
import { FaBook } from 'react-icons/fa6';
import { IconProps } from './common/iconProps';

export const BookIcon: FC<IconProps> = ({ className }) => <FaBook className={className} />;
